import { currencyFormatter } from "utils/currencyHelper";

export function getTotalPool(jackpotPool, game, isJackpotBanner){
    let totalJackpot = 0;
    let isJackpotBannerView = currencyFormatter;
    let balanceView = isJackpotBanner ? "balance" : "jackpotBalance";

    if(jackpotPool !== null){
      jackpotPool && Object.values(jackpotPool).map(value => {
        return totalJackpot+=value.amount;
      })
      if(game.get(balanceView) > totalJackpot) {
        return isJackpotBannerView(game.get(balanceView), {
          currency: this.props.currency,
        })

      } else {
        return isJackpotBannerView(totalJackpot, {
          currency: this.props.currency,
        })
      }
    } else {
      return isJackpotBannerView(game.get(balanceView), {
        currency: this.props.currency,
      })
    }
}